import Component from 'gia/Component'
import _each from 'lodash.foreach'


class Contact extends Component {

  constructor(element) {

    super(element)

  

    this.element = element

    this.index = 0
    this.current = 0


    this.ref = {
      
      newsletter: null

    }

  }

  mount() {
       
    console.log('contact');
    
   
       $(this.ref.newsletter).on('click', (e)=>{
            e.preventDefault()

            document.body.classList.add('has-form')
       })

       $('[data-button="close"]').on('click', (e) => {
           e.preventDefault()

           document.body.classList.remove('has-form')
       })

  }

  




  resize() {

  }

  unmount() {

    // this.observer.disconnect()


   

  }


}

module.exports = Contact